import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Table from "../../../ui/Table";
import { TitleText } from "../../../ui/Text";
import { EditDeleteFormatter } from "../../../ui/TableFormatter";
import Modal from "../../../ui/Modal";
import { PERIOD_URL } from "../../../api/urls";

import axios from "axios";
import AddPeriod from "./AddPeriod";
import { GetHook, putEndpoint } from "../../../api/api";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { get } from "../../../utils/get";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

export const Period = () => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [handleSubmit, setHandleSubmit] = useState();
  const [editData, setEditData] = useState({});
  const [edit, setEdit] = useState(false);
  const { data, error, pending, reload } = GetHook(PERIOD_URL);
  const [period, setPeriod] = useState([]);
  const [updateRes, updateReq] = putEndpoint();

  const location = useLocation();
  const handleEdit: any = (row: any) => {
    setisModalOpen(true);
    setEdit(true);
    setEditData(row);
  };

  useEffect(() => {
    setPeriod(data);
  }, [data]);

  const closeModal = () => {
    setisModalOpen(false);
    setEdit(false);
    setEditData({});
    reload(get(location, "key"));
  };

  const handleDelete = (id: string) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        if (id) {
          axios
            .delete(`${PERIOD_URL}/${id}`)
            .then((res) => {
              setPeriod(period.filter((company: any) => company.id !== id));
              toast.success("Period has been deleted");
              reload(get(location, "key"));
            })
            .catch((error) => toast.error(error.response.data.message));
        }
      }
    });
  };

  const handleClosePeriod = (id) => {
    updateReq(`${PERIOD_URL}/${id}`, { active: false });
  };
  useEffect(() => {
    const { complete, pending, data } = updateRes;
    if (!pending && complete && data && !error) {
      toast.success("Period has been closed");
      reload(get(location, "key"));
    }
  }, [updateRes]);

  const columns = [
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Start date",
      accessor: "start_date",
      Cell: ({ row }) => moment(row.original.start_date).format("DD MMM YYYY"),
    },
    {
      Header: "End date",
      accessor: "end_date",
      Cell: ({ row }) => moment(row.original.end_date).format("DD MMM YYYY"),
    },
    {
      Header: "Grace period",
      accessor: "grace_period_days",
    },
    {
      Header: "close period mode",
      accessor: "close_period_mode",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ row }) =>
        row.original.active === true ? (
          <Status color="#13C997">Active</Status>
        ) : (
          <Status color="#FF6666">Non-Active</Status>
        ),
    },
    {
      id: "1",
      Header: "",
      Cell: ({ row }: any) => (
        <EditDeleteFormatter
          showEdit={() => handleEdit(row.original)}
          handleDelete={() => handleDelete(row.original.id)}
          handleClosePeriod={() => handleClosePeriod(row.original.id)}
        />
      ),
    },
  ];
  return (
    <>
      <CompanyContainer>
        <HeaderContainer>
          <TitleText>Period</TitleText>
        </HeaderContainer>
        <Table data={period} columns={columns} setModal={setisModalOpen} />
      </CompanyContainer>
      {isModalOpen && (
        <Modal
          title={edit ? "Edit Period" : "Add new Period"}
          handleSubmit={handleSubmit}
          closeModal={closeModal}
        >
          <AddPeriod
            closseModal={closeModal}
            setHandleSubmit={setHandleSubmit}
            editData={editData}
            companies={period}
          />
        </Modal>
      )}
    </>
  );
};

const CompanyContainer = styled.div`
  display: grid;
  grid-template-rows: 5em auto;
  background-color: #fff;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.3em;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
`;

const Status = styled.span`
  color: ${(props) => props.color};
  font-size: 12px;
`;
